import { IconProps } from './icons-props';

function VideoCircle({ className, width = 20, height = 20 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.5835 10.0002V8.7669C7.5835 7.17524 8.7085 6.53357 10.0835 7.32524L11.1502 7.9419L12.2168 8.55857C13.5918 9.35024 13.5918 10.6502 12.2168 11.4419L11.1502 12.0586L10.0835 12.6752C8.7085 13.4669 7.5835 12.8169 7.5835 11.2336V10.0002Z'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}

export default VideoCircle;

